import { displayErrorMessage } from "./common";

export function validate(dataRequest, $form, rules) {
  dataRequest = addDataRadioAndCheckboxToForm(dataRequest, $form);
  const errors = {};
  const patternEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  dataRequest.forEach((data) => {
    const ruleKeys = Object.keys(rules).filter(v => data.name === v || data.name.includes(v));
    const ruleName = ruleKeys ? ruleKeys[ruleKeys.length - 1] : null
    const rule = rules[ruleName];
    if (rule) {
      const { name, value } = data;
      const convertName = name.replace(/\[|\]|]\[|]$/g, (match) => {
        if (match === '[') return '.';
        if (match === ']') return '';
      })
      Object.entries(rule).forEach(([key, config]) => {
        if (config.value) {
          errors[convertName] = errors[convertName] || [];
          switch (key) {
            case 'required':
              if (!value) {
                errors[convertName].push(config.message);
              }
              break;

            case 'maxLength':
              if (value.replace(/\D/g, '').length > config.value) {
                errors[convertName].push(config.message);
              }
              break;
            case 'minLength':
              if (value.replace(/\D/g, '').length < config.value) {
                errors[convertName].push(config.message);
              }
              break;
            case 'email':
              if (!patternEmail.test(value)) {
                errors[convertName].push(config.message);
              }
              break;

            case 'max':
              if (value && (Number(value) > config.value)) {
                errors[convertName].push(config.message);
              }
              break;

            case 'min':
              if (value && (Number(value) < config.value)) {
                errors[convertName].push(config.message);
              }
              break;

            case 'number':
              if (typeof value !== 'number') {
                errors[convertName].push(config.message || 'Must be a number!');
              }
              break;
          }

          if (errors[convertName].length === 0) {
            delete errors[convertName];
          }
        }
      });
    }
  });
  if (!jQuery.isEmptyObject(errors)) {
    displayErrorMessage($form, errors)
    return false;
  }
  return true;
}

function addDataRadioAndCheckboxToForm(dataRequest, $form) {
  const namesChecked = {};
  $form.find('input[type=radio], input[type=checkbox]').not(".not_serialize input[type=radio], .not_serialize input[type=checkbox]").each(function () {
    namesChecked[this.name] = namesChecked[this.name] || $(this).prop('checked');
  });
  Object.keys(namesChecked).forEach(function (name) {
    if (!namesChecked[name]) {
      dataRequest.push({ name, value: null });
    }
  });
  return dataRequest;
}
